import { render, staticRenderFns } from "./tmsSubTable.vue?vue&type=template&id=15a64d50&"
import script from "./tmsSubTable.vue?vue&type=script&lang=js&"
export * from "./tmsSubTable.vue?vue&type=script&lang=js&"
import style0 from "./tmsSubTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports